import { Button } from "components/Atoms/Button";
import moment from "moment";
import React, { useRef } from "react";
import Popup from "reactjs-popup";
import { type PopupActions } from "reactjs-popup/dist/types";
import { formatWrittenDateTimeUtc } from "utilities";
import { AdvancingRowIcon, phaseIcons } from "./AdvancingRowIcon";
import { AdvancingSectionField } from "./types";

const getPhaseActionText = (phase: server.dto.AdvancingFormItemPhases) => {
  switch (phase) {
    case "pending": return RESX.AdvancingTimeline.providedInformation;
    case "approved": return RESX.AdvancingTimeline.confirmedTheInput;
    case "declined": return RESX.AdvancingTimeline.declinedTheInput;
    default: throw new Error(`Unexpected phase: ${phase}`);
  }
};

interface Props {
  field: AdvancingSectionField
  trigger: JSX.Element
  onRemove?: () => void
}

export const AdvancingRowPopup = ({ field, trigger, onRemove }: Props) => {
  const popupRef = useRef<PopupActions>(null);
  const lastModifiedUtc = moment.utc(field.lastModifiedUtc);

  return <Popup
    ref={popupRef}
    trigger={trigger}
    position="bottom left"
    closeOnDocumentClick
    contentStyle={{ padding: "0px", border: "none" }}
    arrow={false}
  >
    <div className="advancing-row-popup flex-column gap-larger padding-bigger radius-big">
      {field.phase !== "unknown" && <div className="flex gap">
        <AdvancingRowIcon rowIcon={phaseIcons[field.phase]} />
        <div>
          <div>{field.actorName ?? "[unknown]"} {getPhaseActionText(field.phase)}</div>
          <div className="text-sublabel" title={formatWrittenDateTimeUtc(lastModifiedUtc)}>{lastModifiedUtc.fromNow()}</div>
        </div>
      </div>}
      {onRemove && <Button
        type="warning"
        className="fluid"
        label={RESX.Advancing.RemoveFromAdvancingSession}
        onClick={() => {
          popupRef.current.close();
          onRemove();
        }} />}
    </div>
  </Popup>;
};
